<template>
  <div class="container">
    <div class="bg-block">
      <div class="total-wrap">
        <div class="item border money">
          <div class="money-box">
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="150"
            >
              <p>钱包金额=可提现金额+留存金额+冻结金额</p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
            <span style="margin-left: 5px">钱包金额：</span>
            <span>￥{{ account_amount || 0 }}</span>
          </div>
          <div class="money-box">
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="150"
            >
              <p>
                门店正常运营期间，留存金额不支持提现，用于学员退款周转(目标留存金额为{{
                  withdrawConfig.config
                    ? withdrawConfig.config.retained_amount
                    : "-"
                }}元)
              </p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
            <span style="margin-left: 5px">留存金额：</span>
            <span>￥{{ retained_amount || 0 }}</span>
          </div>
        </div>
        <div class="item border">
          <p class="number">￥{{ withdraw_able_amount }}</p>
          <p class="title">
            可提现金额
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="150"
            >
              <p>已到账可提现的金额</p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </p>
        </div>
        <div class="item border">
          <p class="number">￥{{ freeze_amount }}</p>
          <p class="title">
            冻结金额
            <!-- <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="150"
            >
              <p>提现中的金额</p>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover> -->
          </p>
        </div>
        <div
          class="item"
          v-if="
            merchantInfo.withdraw_status === 1 &&
            withdrawConfig.withdraw_auth === 1 &&
            withdrawConfig.config.auto_switch === 2
          "
        >
          <div class="mwow-button-filled success" @click="toWithdrawal">
            我要提现
          </div>
        </div>
      </div>
    </div>
    <div class="bg-block">
      <el-tabs v-model="activeName" @tab-click="tabChange">
        <el-tab-pane label="收支明细" name="detail">
          <tab-detail :visible="activeName === 'detail'"></tab-detail>
        </el-tab-pane>
        <el-tab-pane label="提现记录" name="log">
          <tab-log :visible="activeName === 'log'"></tab-log>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  getAccountBalanceApi,
  withdrawalInfoApi,
  getMerchantInfoApi,
} from "@/api/storeWallet";
import tabDetail from "../cashier/tabDetail.vue";
import tabLog from "../cashier/tabLog.vue";
import { UserModule } from "@/store/module/user";

export default {
  props: ["visible"],
  components: {
    tabDetail,
    tabLog,
  },
  data() {
    return {
      activeName: "detail",
      account_amount: 0, // 钱包金额
      retained_amount: 0, // 留存金额
      withdraw_able_amount: 0, // 可提现金额
      freeze_amount: 0, // 冻结金额
      withdrawConfig: {}, // 提现配置信息（提现权限）
      merchantInfo: {}, // 商户信息（所有状态）
    };
  },
  computed: {
    online_pay() {
      return UserModule.userInfo.online_pay;
    },
  },
  mounted() {
    // 开通线上支付，调取对应金额接口、商户信息
    if (this.online_pay) {
      // 单次watch页面展示，然后加载数据
      const unwatch = this.$watch("visible", (n) => {
        if (n) {
          this.init();
        }
        this.$nextTick(() => {
          unwatch();
        });
      });
      if (this.visible) {
        this.init();
      }
    }
    let pageCache = sessionStorage.getItem(
      "finance-center-store-wallet-tab-detail-page-cache"
    );
    if (pageCache) {
      let pageCacheJSON = JSON.parse(pageCache);
      if (pageCacheJSON.tab) {
        this.activeName = pageCacheJSON.tab;
      }
    }
  },
  methods: {
    init() {
      withdrawalInfoApi().then((res) => {
        if (res.error_code === 0) {
          this.withdrawConfig = res.data;
        }
      });
      getMerchantInfoApi().then((res) => {
        if (res.error_code === 0) {
          this.merchantInfo = res.data;
        }
      });
      getAccountBalanceApi().then((res) => {
        if (res.error_code === 0) {
          this.account_amount = res.data.account_amount; // 账户总金额
          this.retained_amount = res.data.retained_amount; // 留存金额
          this.withdraw_able_amount = res.data.withdraw_able_amount; // 可提现金额
          this.freeze_amount = res.data.freeze_amount; // 冻结金额
        }
      });
    },
    toWithdrawal() {
      this.$router.push({
        name: "storeWalletWithdrawal",
      });
    },
    tabChange(v) {
      sessionStorage.setItem(
        "finance-center-store-wallet-tab-detail-page-cache",
        JSON.stringify({
          tab: this.activeName,
        })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 85vh;
  .bg-block {
    padding: 0 12px 12px 12px;
    background-color: #ffffff;
    border-radius: 4px;
    margin-bottom: 12px;
    .total-wrap {
      display: flex;
      align-items: center;
      padding: 24px 0;
      .item {
        text-align: center;
        flex: 1;
        &.border {
        }
        .number {
          font-size: 24px;
          line-height: 24px;
          margin-bottom: 12px;
          color: #5c5d5e;
        }
        .title {
          font-size: 14px;
          line-height: 14px;
          color: #5c5d5e;
        }
        .el-icon-question {
          margin: 0 0 0 8px;
          color: #bebfc0 !important;
          font-size: 16px;
          vertical-align: text-bottom;
        }
      }
      .money {
        flex: 0.8;
        border-right: 1px solid #bebfc0;
        .money-box {
          font-size: 14px;
          height: 20px;
          line-height: 20px;
          margin: 10px;
        }
      }
    }
  }
}
</style>
